import { Button, FormControl, ListItem } from "@mui/material";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import FiltroCantiere from "./FiltroCantiere";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import itLocale from "date-fns/locale/it"; 
import { format } from "date-fns";
import FiltroOperatore from "./FiltroOperatore";

const FormRicerca = ({ handleDrawerToggle = () => {} }) => {

  const navigate = useNavigate();  

  const [dataDa, setDataDa] = useState<Date | null>(new Date());
  const [dataA, setDataA] = useState<Date | null>(new Date());
  const [cantiere, onSelectCantiere] = useState<string | null>(null);
  const [operatore, onSelectOperatore] = useState<string | null>(null);

  const onClickRicerca = () => {

    navigate("/marcature", { state: { 

        datada: !!dataDa ? format(dataDa, "yyyy/MM/dd") : null, 
        dataa: !!dataDa ? format(dataDa, "yyyy/MM/dd") : null, 
        idcantiere: cantiere,
        idoperatorecantiere: operatore

    }})

    handleDrawerToggle(); 

  }

  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={itLocale}>
        <ListItem key={"datada"}>
          <DatePicker
            label="Data da"
            value={dataDa}
            onChange={(newValue) => setDataDa(newValue)}
            renderInput={(params) => <TextField {...params} />}
          />
        </ListItem>
        <ListItem key={"dataa"}>
          <DatePicker
            label="Data a"
            value={dataA}
            onChange={(newValue) => setDataA(newValue)}
            renderInput={(params) => <TextField {...params} />}
          />
        </ListItem>
        <FiltroCantiere onSelectCantiere={(cantiere: string | null) => onSelectCantiere(cantiere)} />
        <FiltroOperatore onSelectOperatore={(operatore: string | null) => onSelectOperatore(operatore)} />
        <ListItem key={"cerca"}>
          <FormControl fullWidth>
            <Button onClick={() => onClickRicerca()}variant="contained">Cerca</Button>
          </FormControl>
        </ListItem>
      </LocalizationProvider>
    </div>
  );
};

export default FormRicerca; 